import GlobalSelections from './container';

export default GlobalSelections;
